import React, { useRef, useEffect, useState, useCallback } from 'react';
import { Bar } from "react-chartjs-2";
import { BarElement,  CategoryScale, Chart,Legend, LinearScale,Title, Tooltip } from "chart.js";

<script src="../../node_modules/chart.js/dist/chart.umd.js"></script>
Chart.register(CategoryScale, LinearScale, BarElement,Title,Tooltip,Legend);
Chart.defaults.font.size = 12;
Chart.defaults.maintainAspectRatio = false;

function transformColumnDesc(str) {
    let result = '\n';
    let spaceCount = 0;

    for (let i = 0; i < str.length; i++) {
        if (str[i] === ' ') {
            spaceCount++;
            if (spaceCount % 8 === 0) {
                result += ' \n';
                continue;
            }
        }
        result += str[i];
    }

    return result;
}


export default function CreateBarData(props) {

    let social_groups = [
    props.census['percent_asian']['column_disp_name'].replace('% ', ""),
    props.census['percent_white']['column_disp_name'].replace('% ', ""),
    props.census['percent_black']['column_disp_name'].replace('% ', ""),
    props.census['percent_hispanic']['column_disp_name'].replace('% ', ""),
    props.census['percent_other']['column_disp_name'].replace('% ', "")
];

        const option = {
        scales: {
        y: {
          title: {
            display: true,
            text: 'Percentage of Population',
              font :{
                    size: 12
                }
          },
            grid:{
                  drawOnChartArea:false
              }
        },
            x: {
            ticks: {social_groups,
                font: {
                    size: 12,
                }},
              color: 'black',
              grid:{
                  drawOnChartArea:false
              },
            },

      },
      responsive: true,
        plugins: {
            tooltip: {
                callbacks: {
                    afterBody: function(context) {
                        let desc = props.census[`percent_${context[0].label.toLowerCase()}`]['column_desc'];
                        return transformColumnDesc(desc);
                    }
                },
                bodyFont: {
                    maxWidth: 50
                },
            },
            legend: {
                display: false
            }
        },
    };
    const data = { labels : social_groups,
        datasets: [
    {
    label: "Percentage of Population",
    data: [props.census['percent_asian']['value'], props.census['percent_white']['value'], props.census['percent_black']['value'], props.census['percent_hispanic']['value'], props.census['percent_other']['value']],
    backgroundColor: 'rgba(92,145,227,255)',
    },
    ],


    };

  return (
    <div className='graph'>
        <Bar data={data} options={option}/>
    </div>
  );
}